<mat-card>
  <mat-card-header>
    <mat-card-title>Session Timeout</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <p>
      You have been inactive for {{timeout}} minutes and your session is about the expire. For security, you will be
      signed out if you don’t do something soon. If you are signed out, any changes will be lost and you will need to
      sign in again.

    </p>
    <div *ngIf="sessionsToDone > 0">Your current session will expire in {{sessionsToDone}} seconds.</div>
    <div *ngIf="sessionsToDone <= 0">Session has expired</div>
  </mat-card-content>
  <mat-card-actions>
    <button mat-raised-button color="accent" (click)="onNoClick()">Close</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="'refresh'" [disabled]="sessionsToDone <= 0"
      (click)="afterClosed()">Refresh Session</button>
  </mat-card-actions>

</mat-card>
